
import { moodleStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';

interface Opcao {
  text: string;
  correct: boolean;
  selected?: boolean;
}

interface Pergunta {
  question: string;
  options: Opcao[];
}

interface MensagemDialog {
  type: 'sair' | 'finalizado' | 'nao-finalizado';
  title: string;
  subtitle?: string;
  text: string;
  icon?: string;
  iconColor?: string;
  primaryActionText: string;
  secondaryActionText: string;
  colorText?: string;
  colorTitle?: string;
}

@Component
export default class QuizPlayer extends Vue {
  perguntas: Pergunta[] = [];
  perguntaAtualIndex: number = 0;
  opcaoSelecionada: Opcao | null = null;
  acertos: number = 0;
  respondeu: boolean = false;
  teste = false;
  finalizado: boolean = false;
  mensagensDialog: MensagemDialog[] = [
    {
      type: 'sair',
      title: 'Atenção',
      subtitle: 'Atenção: Você perderá todo o seu progresso!',
      text: 'Se você sair agora, todo o seu processo será perdido e não poderá ser desfeito. Tem certeza de que deseja sair?',
      icon: 'exclamation',
      iconColor: 'red',
      primaryActionText: 'Quero continuar com o desafio',
      secondaryActionText: 'Sair e cancelar meu progresso',
      colorText: 'red900',
      colorTitle: 'white',
    },
    {
      type: 'finalizado',
      title: 'Parabéns! 🎉 ',
      subtitle: 'Você concluiu o Desafio!',
      text: 'Continue se desafiando! Conclua mais desafios para conquistar novas badges e evoluir ainda mais. 🚀 ',
      iconColor: 'green',
      primaryActionText: 'Retornar ao Início',
      secondaryActionText: 'Ver minhas Badges',
      colorText: 'primary',
      colorTitle: 'primary',
    },
    {
      type: 'nao-finalizado',
      title: 'Ops! Você não concluiu o desafio dessa vez.',
      text: 'Não se preocupe, você pode tentar novamente! Revise o conteúdo e tente responder as perguntas mais uma vez. Boa sorte! 💪',
      primaryActionText: 'Voltar ao conteúdo',
      secondaryActionText: 'Refazer o Desafio',
      colorText: 'red900',
      colorTitle: 'red900',
    },
  ];
  mensagemDialogAtual: MensagemDialog = this.mensagensDialog[0];
  quizId: number | null = null;

  get perguntaAtual(): Pergunta {
    return this.perguntas[this.perguntaAtualIndex];
  }

  get counter(): number {
    return this.perguntaAtualIndex + 1;
  }

  async mounted() {
    await this.carregarQuiz();
  }

  decodeHTML(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  mapearPerguntasBrutas(questoes: any[]): Pergunta[] {
    return questoes.map((q) => ({
      question: this.decodeHTML(q.questiontext),
      options: q.answers.map((a: any) => ({
        text: this.decodeHTML(a.text),
        correct: a.fraction > 0,
      })),
    }));
  }

  async carregarQuiz() {
    const { cursoId, titulo } = this.$route.query as {
      cursoId: string;
      titulo: string;
    };

    try {
      // Primeiro verifica se já temos o conteúdo do curso carregado
      let conteudoCurso = moodleStore.getConteudoCurso;
      
      // Se não tiver, busca do servidor
      if (!conteudoCurso || conteudoCurso.length === 0) {
        await moodleStore.fetchCourseContent(parseInt(cursoId));
        conteudoCurso = moodleStore.getConteudoCurso;
      }

      if (!conteudoCurso || !Array.isArray(conteudoCurso)) {
        console.error('Erro ao carregar conteúdo do curso');
        return;
      }

      const secao = conteudoCurso.find(
        (s: any) => s.name?.toLowerCase().trim() === titulo.toLowerCase().trim()
      );

      if (!secao) {
        console.error('Seção não encontrada');
        return;
      }

      const quizModule = secao.modules.find((m: any) => m.modname === 'quiz');

      if (quizModule) {
        this.quizId = quizModule.instance;
        const perguntasApi = await moodleStore.fetchQuizQuestions(quizModule.instance);
        this.perguntas = this.mapearPerguntasBrutas(perguntasApi || []);
      }
    } catch (error) {
      console.error('Erro ao carregar quiz:', error);
    }
  }

  responder(opcao: Opcao) {
    if (this.respondeu || !opcao) return;
    this.respondeu = true;
    opcao.selected = true;

    if (opcao.correct) {
      this.acertos++;
      setTimeout(this.proximaPergunta, 800);
    } else {
      this.mensagemDialogAtual = this.mensagensDialog[2];
      this.teste = true;
      this.finalizado = true;
      this.salvarRespostaQuiz();
    }
  }

  proximaPergunta() {
    if (this.perguntaAtualIndex < this.perguntas.length - 1) {
      this.perguntaAtualIndex++;
      this.respondeu = false;
      this.opcaoSelecionada = null;
    } else {
      this.finalizado = true;
      this.teste = true;

      if (this.acertos === this.perguntas.length) {
        this.mensagemDialogAtual = this.mensagensDialog[1];
      } else {
        this.mensagemDialogAtual = this.mensagensDialog[2];
      }
      this.salvarRespostaQuiz();
    }
  }

  fecharQuiz() {
    this.$router.back();
  }

  continuarDesafio() {
    if (this.mensagemDialogAtual.type === 'nao-finalizado') {
      this.fecharQuiz();
    } else if (this.mensagemDialogAtual.type === 'finalizado') {
      this.$router.push({
        path: '/main/universidadeknn/all',
        query: { activeTab: '1' },
      });
    } else {
      this.teste = false;
    }
  }

  reiniciarQuiz() {
    this.teste = false;
    this.finalizado = false;
    this.acertos = 0;
    this.perguntaAtualIndex = 0;
    this.opcaoSelecionada = null;
    this.respondeu = false;
  }

  sairCancelarProgresso() {
    if (this.mensagemDialogAtual.type === 'nao-finalizado') {
      this.reiniciarQuiz();
    } else if (this.mensagemDialogAtual.type === 'finalizado') {
      this.$router.push({
        path: '/main/universidadeknn/all',
        query: { activeTab: '1', BadgeDialog: 'true' },
      });
    } else {
      this.teste = false;
      this.fecharQuiz();
    }
  }

  async salvarRespostaQuiz() {
    if (!this.quizId) {
      console.error('ID do quiz não encontrado.');
      return;
    }
    if (!moodleStore.getUserData) {
      console.error('Dados do usuário não encontrados.');
      return;
    }

    const accuracy_percentage = Math.round((this.acertos / this.perguntas.length) * 100);

    const payload = {
      lms_quiz_id: this.quizId,
      user_id: moodleStore.getUserData.id,
      accuracy_percentage: accuracy_percentage,
    };

    try {
      await moodleStore.saveQuizAnswer(payload);
    } catch (error) {
      console.error('Erro ao salvar resposta do quiz:', error);
    }
  }
}
